'use client';

import { ReactNode } from 'react';

interface FloatingNavBarOverflowMenuProps {
  children: ReactNode;
}

/**
 * @description Wraps nav-bar items in a centered flex row. On mobile, items
 * wrap to a second row and are centered when they exceed the available width.
 */
export const FloatingNavBarOverflowMenu = ({ children }: FloatingNavBarOverflowMenuProps) => (
  <div className="flex flex-wrap items-center justify-center gap-1.5 lg:flex-nowrap lg:gap-5">
    {children}
  </div>
);
